import { ModalDialog } from '@uhg-abyss/web/ui/ModalDialog';
import { FindhelpProgram } from '@src/api.types';
import { DetailsPage } from '../ExpandedPage/DetailsPageFindhelp';
import { UniteUsProgram } from '@repo/ui';
import { DetailsPageUnitUs } from '../ExpandedPage/DetailsPageUniteUs';
export type CboDetailModalProps = {
  isOpen: boolean;
  onClose: () => void;
  program: FindhelpProgram | UniteUsProgram;
  isPrinting: boolean;
  vendor: 'findhelp' | 'uniteus';
};

export function CboDetailModal({
  isOpen,
  onClose,
  program,
  isPrinting,
  vendor,
}) {
  return (
    <ModalDialog
      isOpen={isOpen}
      size={1200}
      onClose={onClose}
    >
      <div data-cy="cbo-modal-content-section">
        {vendor === 'findhelp' ? (
          <DetailsPage
            programData={program as FindhelpProgram}
            printTab={isPrinting}
          />
        ) : (
          <DetailsPageUnitUs
            programData={program as UniteUsProgram}
            printTab={isPrinting}
          />
        )}
      </div>
    </ModalDialog>
  );
}
